import {DeleteRecordsConfirmationButton} from '@flexinet/ui-components';
import {useMutation, useQueryClient} from "@tanstack/react-query";
import {deleteRecord} from "../services/SubscriptionItemsService.ts";
import {useSubscriptionItemsSelection} from "../hooks/useSubscriptionItemsSelection.ts";

export const DeleteRecordButton = () => {
    const {selectedRecords, clearSelection} = useSubscriptionItemsSelection();
    const queryClient = useQueryClient();

    const mutation = useMutation({
        mutationFn: async () => {
            await Promise.all(selectedRecords.map(record => deleteRecord(record.id)));
            clearSelection();
        },
        onSuccess: () => {
            queryClient.invalidateQueries({queryKey: ['subscription-items']});
        }
    });

    return (
        <DeleteRecordsConfirmationButton
            disabled={selectedRecords.length === 0}
            recordIdsLength={selectedRecords.length}
            handleConfirm={mutation.mutate}
        />
    );
};